import React, { ChangeEventHandler, ReactNode } from 'react';
import { tv } from 'tailwind-variants';
import Typography from '../Typography';

const checkboxVariants = tv({
  slots: {
    label:
      'inline-flex items-start gap-2 mb-3 cursor-pointer select-none text-sm leading-5 text-neutral-dark',
    input: 'sr-only peer',

    indicator:
      'relative flex-shrink-0 mt-[1px] h-[18px] w-[18px] rounded-sm border transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-2',

    icon: 'absolute inset-0 flex items-center justify-center',
  },
  variants: {
    checked: {
      true: {
        // theme() inside arbitrary value — gera classe única, sem conflito com Bootstrap !important
        indicator: 'bg-[theme(colors.primary.medium)] border-[theme(colors.primary.medium)]',
        icon: 'visible',
      },
      false: {
        indicator: 'bg-[theme(colors.neutral.lightest)] border-[theme(colors.neutral.medium)]',
        icon: 'invisible',
      },
    },
    disabled: {
      true: {
        label: 'cursor-not-allowed opacity-50',
      },
    },
  },
  defaultVariants: {
    checked: false,
  },
});

interface CheckboxProperties {
  label: ReactNode;
  value: boolean;
  disabled?: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClick?: () => void;
  id?: string;
}

const Checkbox = ({ label, value, disabled, onChange, onClick, id }: CheckboxProperties) => {
  const {
    label: labelClass,
    input: inputClass,
    indicator: indicatorClass,
    icon: iconClass,
  } = checkboxVariants({ checked: value, disabled });

  return (
    <label id={id} className={labelClass()}>
      <input
        type="checkbox"
        checked={value}
        onChange={onChange}
        onClick={onClick}
        disabled={disabled}
        className={inputClass()}
      />
      <span data-testid="checkbox-indicator" className={indicatorClass()}>
        <span data-testid="checkbox-checkmark" className={iconClass()}>
          <svg width="10" height="8" viewBox="0 0 10 8" fill="none" aria-hidden="true">
            <path
              d="M1 3.5L3.5 6.5L9 1"
              stroke="#FCFDFC"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </span>
      <Typography>{label}</Typography>
    </label>
  );
};

export default Checkbox;
